module.exports = __webpack_public_path__ + "img/papaya.9cea2372.png";